import { render } from "./EvaluateEnrolled.vue?vue&type=template&id=674c884a"
import script from "./EvaluateEnrolled.vue?vue&type=script&lang=js"
export * from "./EvaluateEnrolled.vue?vue&type=script&lang=js"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__